import React, { useState } from 'react';

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Levels from './components/levels/Levels';
import Benefits from './components/benefits/Benefits';
import Actions from './components/actions/Actions';
import Badges from './components/badges/Badges';

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  container: {},
}));

enum TabValues {
  Levels = 'Levels',
  Benefits = 'Benefits',
  Actions = 'Actions',
  Badges = 'Badges',
}

const RewardsSettingsList = (props) => {
  const classes = useStyles();
  const [tab, setTab] = useState<TabValues>(TabValues.Levels);

  const handleChangeTab = (event, value) => {
    setTab(value);
  };

  return (
    <Box className={classes.container}>
      <Typography className={classes.title}>Rewards Settings</Typography>
      <Tabs
        component={React.Fragment}
        indicatorColor="primary"
        textColor="primary"
        value={tab}
        onChange={handleChangeTab}>
        <Tab value={TabValues.Levels} label="Levels" />
        <Tab value={TabValues.Benefits} label="Perks" />
        <Tab value={TabValues.Actions} label="Actions" />
        <Tab value={TabValues.Badges} label="Badges" />
      </Tabs>
      {tab === TabValues.Levels && <Levels {...props} />}
      {tab === TabValues.Benefits && <Benefits {...props} />}
      {tab === TabValues.Actions && <Actions {...props} />}
      {tab === TabValues.Badges && <Badges {...props} />}
    </Box>
  );
};

export default RewardsSettingsList;
